<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.35" d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" fill="currentColor"/>
    <path d="M7 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M17 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M3 10H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <circle cx="12" cy="15" r="2" fill="currentColor"/>
    <path d="M16 15H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TodaysCallsIcon'
}
</script>

